/** English builder UI strings (default language). */

export const en = {
  widgetBuilder: 'Widget Builder',
  languageSection: 'Language',
  interfaceLanguage: 'Builder language',
  interfaceLanguageHint: 'Menus, buttons, labels, and widget text on your site.',
  configure: 'Configure',
  preview: 'Preview',
  embed: 'Embed',
  myWidgets: 'My widgets',
  savedCount: '{count} saved',
  newWidget: '+ New widget',
  noSavedYet: 'No saved widgets yet. Configure below — changes save automatically.',
  newDraft: 'New draft — edits auto-save.',
  delete: 'Delete',
  deleteConfirm: 'Delete this saved widget?',
  untitled: 'Untitled',
  changesInstant: 'Changes update the preview instantly.',
  saving: 'Saving…',
  unsavedChanges: 'Unsaved changes…',
  saveError: 'Could not save to cloud storage. Restart the API server and try again.',
  savedCloud: 'Saved to database.',
  savedLocal: 'Saved locally (database offline).',
  autoSaved: 'Auto-saved {time}',
  changesAutoSave: 'Changes save automatically.',
  saveNow: 'Save now',
  widgetId: 'ID',
  widgetName: 'Widget name',
  widgetType: 'Widget type',
  widgetLanguage: 'Widget language (embed)',
  widgetLanguageHint: 'Language visitors see inside the widget. Edit strings in src/i18n/widgetLabels.js',
  theme: 'Theme',
  themeRequired: 'Required at creation; preserved in embed.',
  themeLight: 'Light',
  themeDark: 'Dark',
  allowedDomains: 'Allowed domains (embed)',
  allowedDomainsHint:
    'One domain per line. Leave empty to allow any site. localhost is always allowed in dev.',
  domainsPlaceholder: 'example.com\nwww.myblog.com',
  accentColor: 'Accent color',
  hintTeamInjuries:
    'Use the Team dropdown above the preview: leave on All teams for a list grouped by club, or pick one club.',
  hintTeamPlayerList:
    'Choose a club in the Team dropdown above the preview to show the full squad with player details.',
  hintTeamProfile: 'Choose a team in the Team dropdown in the bar above the preview.',
  hintPlayerPicker: 'Choose a player in the Player dropdown in the bar above the preview.',
  hintSelectMatchBar:
    'Pick a fixture in the Match dropdown in the bar above (next to Competition). Auto picks the best available game if you leave it on Auto.',
  competition: 'Competition',
  player: 'Player',
  team: 'Team',
  match: 'Match',
  groupFeatured: 'Featured',
  groupAllLeagues: 'All leagues',
  groupSelection: 'Selection',
  groupDefault: 'Default',
  groupPlayers: 'Players',
  groupClubs: 'Clubs in league',
  groupLive: 'Live',
  groupFinishedLineups: 'Finished — with lineups',
  groupFinished: 'Finished',
  groupUpcoming: 'Upcoming',
  matchAuto: 'Auto (latest / best available)',
  matchAutoSub: 'Picks live, then recent finished match with data',
  topScorer: 'Top scorer',
  teamAllGrouped: 'All teams (grouped by club)',
  teamFirstInTable: 'First in table',
  hintTeamInjuriesPicker:
    'All teams shows each club separately; pick one club to show only their injured players',
  hintTeamPlayerListPicker: 'Pick a club to show the full squad with player details',
  hintTeamProfilePicker: 'Pick a club for the team profile widget',
  hintPlayerPickerBar: 'Pick a player for the profile widget',
  searchCompetitions: 'Search competitions…',
  searchPlayers: 'Search players…',
  searchTeams: 'Search teams…',
  searchMatches: 'Search matches…',
  noCompetitions: 'No competitions found',
  noPlayer: 'No player found',
  noTeam: 'No team found',
  noMatches: 'No matches match your search',
  loadingLeagues: 'Loading leagues…',
  competitionsFilter: '{count} competitions — type to filter',
  loadingFixtures: 'Loading fixtures from season schedule…',
  previewSelectedOnly: 'Preview shows the selected fixture only',
  matchesPick: '{count} matches — pick any round (lineups when available)',
  noFixturesAuto: 'No fixtures listed — preview uses auto-picked match',
  loading: 'Loading…',
  competitionsCount: '{count} competitions',
  embedCode: 'Embed code',
  embedIntro: 'Copy and paste into your site HTML.',
  embedThemeNote:
    'Theme: {theme}. Optional domain whitelist in Configure restricts where this embed can load.',
  copied: 'Copied!',
  copyEmbed: 'Copy embed code',
  openLiveEmbed: 'Open live embed page',
  openEmbedTest: 'Open embed test page',
  embedDevNote: 'Dev: URLs use localhost. Script tab loads /embed.js (same widget as iframe).',
  embedWidgetId: 'Widget ID',
  tabIframe: 'Iframe',
  tabScript: 'Script',
  cat_match: 'Match',
  cat_live: 'Live & schedule',
  cat_league: 'League table',
  cat_team: 'Team',
  cat_player: 'Player',
  cat_stats: 'Player stats',
  wt_match_card_label: 'Match Card',
  wt_match_card_desc: 'Score, venue, goals, cards, coaches',
  wt_match_info_label: 'Match Info',
  wt_match_info_desc: 'Venue, attendance, referee, coaches',
  wt_goals_list_label: 'Goals List',
  wt_goals_list_desc: 'Goal scorers for a selected match',
  wt_match_events_label: 'Match Events',
  wt_match_events_desc: 'Goals, cards, subs, VAR timeline',
  wt_lineups_label: 'Lineups',
  wt_lineups_desc: 'Formations, XI, bookings, subs',
  wt_coach_card_label: 'Coach Card',
  wt_coach_card_desc: 'Head coaches for a match',
  wt_live_scores_label: 'Live Scores',
  wt_live_scores_desc: 'Mixed live, upcoming & results',
  wt_live_matches_label: 'Live Now',
  wt_live_matches_desc: 'In-play matches only',
  wt_fixtures_label: 'Fixtures',
  wt_fixtures_desc: 'Upcoming kickoffs',
  wt_results_label: 'Results',
  wt_results_desc: 'Finished match scores',
  wt_standings_label: 'Standings',
  wt_standings_desc: 'Overall, home & away tables',
  wt_group_standings_label: 'Group Tables',
  wt_group_standings_desc: 'Tournament group stages',
  wt_form_guide_label: 'Form Guide',
  wt_form_guide_desc: 'Recent form string per team',
  wt_team_stats_label: 'Goals For/Against',
  wt_team_stats_desc: 'Attack & defence from table',
  wt_team_list_label: 'Team List',
  wt_team_list_desc: 'All clubs in the league with table position & qualification status',
  wt_team_profile_label: 'Team Profile',
  wt_team_profile_desc: 'One club — stats, form, Champions League / Europa / relegation zone',
  wt_player_list_label: 'Player List',
  wt_player_list_desc: 'Full squad for one club — age, nationality, position & stats',
  wt_player_profile_label: 'Player Profile',
  wt_player_profile_desc: 'One player — goals, assists, appearances',
  wt_top_scorers_label: 'Top Scorers',
  wt_top_scorers_desc: 'Goals leaderboard',
  wt_top_assists_label: 'Top Assists',
  wt_top_assists_desc: 'Assist leaderboard',
  wt_appearances_label: 'Appearances',
  wt_appearances_desc: 'Most games played',
  wt_minutes_label: 'Minutes Played',
  wt_minutes_desc: 'Most minutes on pitch',
  wt_discipline_label: 'Cards',
  wt_discipline_desc: 'Yellow & red card totals',
  wt_injuries_label: 'Injuries',
  wt_injuries_desc: 'Players marked injured in squads',
};
